import React from 'react';
import { IMAGE_FORMATS_PRIORITY } from '../../utils/misc';
import styled from 'styled-components';

const ImageBase = ({ className, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) => (
    <img className={className} {...props} />
);

const Image = styled(ImageBase)`
    display: block;
    height: auto;
    position: relative;
    width: 100%;
    z-index: 1;
`;

type Props = {
    images?: { [format: string]: string },
    fallback?: string,
    title?: string,
    lazy?: boolean,
    className?: string
};

function onImageLoad(event: React.SyntheticEvent<HTMLImageElement>) {
    const target = event.target as HTMLImageElement;
    const parent = target.parentElement;
    
    if (parent) {
        parent.classList.remove('shimmer-h');
    }
}

export const PictureWithSources = ({ images, fallback, title, lazy, className }: Props) => {
    const result: JSX.Element[] = [];
    
    if (images) {
        const order = IMAGE_FORMATS_PRIORITY;

        for (const foramt of order) {
            if (!(foramt in images)) continue;
            const src = images[foramt];
            result.push(<source key={foramt} srcSet={src} type={`image/${foramt}`} />);
        }
    }

    const pictureClassName = [className, lazy ? 'shimmer-h' : null].filter(Boolean).join(' ');

    return <picture className={pictureClassName}>
        {result}
        <Image loading={lazy ? 'lazy' : undefined} src={fallback} alt={title} onLoad={lazy ? onImageLoad : undefined}/>
    </picture>;
};
